import { h, Fragment } from "preact";
import { useNavigate } from "react-router-dom";
import OverviewSection from "./OverviewSection";
import ServiceInfoSection from "./ServiceInfoSection";
import { useEffect } from "preact/hooks";


export default function DashboardPage(props) {
    //temporary solution for release
    const navigate = useNavigate();

    useEffect(() => {
        navigate("/transactions");
    }, [navigate]);

    return null;    

    // return (
    //     <>
    //         <OverviewSection />
    //         <br />
    //         <ServiceInfoSection
    //             title={"Liveness detection"}
    //             service_name={"verilive"}
    //         />
    //         <ServiceInfoSection
    //             title={"Document recognition"}
    //             service_name={"veridoc"}
    //         />
    //         <ServiceInfoSection
    //             title={"Face recoginition"}
    //             service_name={"veriface"}
    //         />
    //     </>
    // );
}
